import React from 'react';
import { brandLogo, brandName } from '../lib/brand';

// Logo image when the company uploaded one, otherwise the company name as a wordmark.
export const BrandLogo = ({ height = 36, className = '', style = {}, light = false }) => {
  const src = brandLogo();
  if (src) {
    return <img src={src} alt={brandName()} className={className} style={{ height, width: 'auto', ...style }} data-testid="brand-logo" />;
  }
  return (
    <span className={`heading-font ${className}`} data-testid="brand-wordmark"
      style={{ fontWeight: 900, textTransform: 'uppercase', fontSize: Math.round(height * 0.6), letterSpacing: '-0.01em', color: light ? '#fff' : 'inherit', whiteSpace: 'nowrap', maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block', lineHeight: 1.1, ...style }}>
      {brandName()}
    </span>
  );
};

export default BrandLogo;
